import * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WebhookCredentialDetailFragment = { __typename?: 'WebhookCredential', id: string, environmentId: string, name: string, clientId: string, clientSecret: string, identityUrl: string, expirySeconds: number, created: string, updated: string, configuration?: unknown | null, webhookEndpoints: { __typename?: 'WebhookEndpointsConnection', totalCount: number } };

export type WebhookCredentialListQueryVariables = Types.Exact<{
  environmentId: Types.Scalars['String']['input'];
  orderBy?: Array<Types.WebhookCredentialsOrderBy> | Types.WebhookCredentialsOrderBy;
}>;


export type WebhookCredentialListQuery = { __typename?: 'Query', webhookCredentials?: { __typename?: 'WebhookCredentialsConnection', totalCount: number, nodes: Array<{ __typename?: 'WebhookCredential', id: string, environmentId: string, name: string, clientId: string, clientSecret: string, identityUrl: string, expirySeconds: number, created: string, updated: string, configuration?: unknown | null, webhookEndpoints: { __typename?: 'WebhookEndpointsConnection', totalCount: number } }> } | null };

export type GetWebhookCredentialQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  environmentId: Types.Scalars['String']['input'];
}>;


export type GetWebhookCredentialQuery = { __typename?: 'Query', webhookCredential?: { __typename?: 'WebhookCredential', id: string, environmentId: string, name: string, clientId: string, clientSecret: string, identityUrl: string, expirySeconds: number, created: string, updated: string, configuration?: unknown | null, webhookEndpoints: { __typename?: 'WebhookEndpointsConnection', totalCount: number } } | null };

export type AddWebhookCredentialMutationVariables = Types.Exact<{
  environmentId: Types.Scalars['String']['input'];
  name: Types.Scalars['String']['input'];
  configuration: Types.Scalars['JSON']['input'];
}>;


export type AddWebhookCredentialMutation = { __typename?: 'Mutation', createWebhookCredential?: { __typename?: 'CreateWebhookCredentialPayload', webhookCredential?: { __typename?: 'WebhookCredential', id: string, environmentId: string, name: string, clientId: string, clientSecret: string, identityUrl: string, expirySeconds: number, created: string, updated: string, configuration?: unknown | null, webhookEndpoints: { __typename?: 'WebhookEndpointsConnection', totalCount: number } } | null } | null };

export type UpdateWebhookCredentialMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  environmentId: Types.Scalars['String']['input'];
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
  configuration: Types.Scalars['JSON']['input'];
}>;


export type UpdateWebhookCredentialMutation = { __typename?: 'Mutation', updateWebhookCredential?: { __typename?: 'UpdateWebhookCredentialPayload', webhookCredential?: { __typename?: 'WebhookCredential', id: string, environmentId: string, name: string, clientId: string, clientSecret: string, identityUrl: string, expirySeconds: number, created: string, updated: string, configuration?: unknown | null, webhookEndpoints: { __typename?: 'WebhookEndpointsConnection', totalCount: number } } | null } | null };

export type DeleteWebhookCredentialMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  environmentId: Types.Scalars['String']['input'];
}>;


export type DeleteWebhookCredentialMutation = { __typename?: 'Mutation', deleteWebhookCredential?: { __typename?: 'DeleteWebhookCredentialPayload', webhookCredential?: { __typename?: 'WebhookCredential', id: string, environmentId: string, name: string, clientId: string, clientSecret: string, identityUrl: string, expirySeconds: number, created: string, updated: string, configuration?: unknown | null, webhookEndpoints: { __typename?: 'WebhookEndpointsConnection', totalCount: number } } | null } | null };

export const WebhookCredentialDetailFragmentDoc = gql`
    fragment WebhookCredentialDetail on WebhookCredential {
  id
  environmentId
  name
  clientId
  clientSecret
  identityUrl
  expirySeconds
  created
  updated
  configuration
  webhookEndpoints: webhookEndpointsByEnvironmentIdAndWebhookCredentialId {
    totalCount
  }
}
    `;
export const WebhookCredentialListDocument = gql`
    query WebhookCredentialList($environmentId: String!, $orderBy: [WebhookCredentialsOrderBy!]! = [ID_DESC]) {
  webhookCredentials(
    orderBy: $orderBy
    condition: {environmentId: $environmentId}
  ) {
    nodes {
      ...WebhookCredentialDetail
    }
    totalCount
  }
}
    ${WebhookCredentialDetailFragmentDoc}`;

/**
 * __useWebhookCredentialListQuery__
 *
 * To run a query within a React component, call `useWebhookCredentialListQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebhookCredentialListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebhookCredentialListQuery({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useWebhookCredentialListQuery(baseOptions: Apollo.QueryHookOptions<WebhookCredentialListQuery, WebhookCredentialListQueryVariables> & ({ variables: WebhookCredentialListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebhookCredentialListQuery, WebhookCredentialListQueryVariables>(WebhookCredentialListDocument, options);
      }
export function useWebhookCredentialListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebhookCredentialListQuery, WebhookCredentialListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebhookCredentialListQuery, WebhookCredentialListQueryVariables>(WebhookCredentialListDocument, options);
        }
export function useWebhookCredentialListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WebhookCredentialListQuery, WebhookCredentialListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebhookCredentialListQuery, WebhookCredentialListQueryVariables>(WebhookCredentialListDocument, options);
        }
export type WebhookCredentialListQueryHookResult = ReturnType<typeof useWebhookCredentialListQuery>;
export type WebhookCredentialListLazyQueryHookResult = ReturnType<typeof useWebhookCredentialListLazyQuery>;
export type WebhookCredentialListSuspenseQueryHookResult = ReturnType<typeof useWebhookCredentialListSuspenseQuery>;
export type WebhookCredentialListQueryResult = Apollo.QueryResult<WebhookCredentialListQuery, WebhookCredentialListQueryVariables>;
export const GetWebhookCredentialDocument = gql`
    query GetWebhookCredential($id: String!, $environmentId: String!) {
  webhookCredential(id: $id, environmentId: $environmentId) {
    ...WebhookCredentialDetail
  }
}
    ${WebhookCredentialDetailFragmentDoc}`;

/**
 * __useGetWebhookCredentialQuery__
 *
 * To run a query within a React component, call `useGetWebhookCredentialQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebhookCredentialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebhookCredentialQuery({
 *   variables: {
 *      id: // value for 'id'
 *      environmentId: // value for 'environmentId'
 *   },
 * });
 */
export function useGetWebhookCredentialQuery(baseOptions: Apollo.QueryHookOptions<GetWebhookCredentialQuery, GetWebhookCredentialQueryVariables> & ({ variables: GetWebhookCredentialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebhookCredentialQuery, GetWebhookCredentialQueryVariables>(GetWebhookCredentialDocument, options);
      }
export function useGetWebhookCredentialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebhookCredentialQuery, GetWebhookCredentialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebhookCredentialQuery, GetWebhookCredentialQueryVariables>(GetWebhookCredentialDocument, options);
        }
export function useGetWebhookCredentialSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebhookCredentialQuery, GetWebhookCredentialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWebhookCredentialQuery, GetWebhookCredentialQueryVariables>(GetWebhookCredentialDocument, options);
        }
export type GetWebhookCredentialQueryHookResult = ReturnType<typeof useGetWebhookCredentialQuery>;
export type GetWebhookCredentialLazyQueryHookResult = ReturnType<typeof useGetWebhookCredentialLazyQuery>;
export type GetWebhookCredentialSuspenseQueryHookResult = ReturnType<typeof useGetWebhookCredentialSuspenseQuery>;
export type GetWebhookCredentialQueryResult = Apollo.QueryResult<GetWebhookCredentialQuery, GetWebhookCredentialQueryVariables>;
export const AddWebhookCredentialDocument = gql`
    mutation AddWebhookCredential($environmentId: String!, $name: String!, $configuration: JSON!) {
  createWebhookCredential(
    input: {webhookCredential: {environmentId: $environmentId, name: $name, configuration: $configuration}}
  ) {
    webhookCredential {
      ...WebhookCredentialDetail
    }
  }
}
    ${WebhookCredentialDetailFragmentDoc}`;

/**
 * __useAddWebhookCredentialMutation__
 *
 * To run a mutation, you first call `useAddWebhookCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWebhookCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWebhookCredentialMutation, { data, loading, error }] = useAddWebhookCredentialMutation({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      name: // value for 'name'
 *      configuration: // value for 'configuration'
 *   },
 * });
 */
export function useAddWebhookCredentialMutation(baseOptions?: Apollo.MutationHookOptions<AddWebhookCredentialMutation, AddWebhookCredentialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWebhookCredentialMutation, AddWebhookCredentialMutationVariables>(AddWebhookCredentialDocument, options);
      }
export type AddWebhookCredentialMutationHookResult = ReturnType<typeof useAddWebhookCredentialMutation>;
export type AddWebhookCredentialMutationResult = Apollo.MutationResult<AddWebhookCredentialMutation>;
export type AddWebhookCredentialMutationOptions = Apollo.BaseMutationOptions<AddWebhookCredentialMutation, AddWebhookCredentialMutationVariables>;
export const UpdateWebhookCredentialDocument = gql`
    mutation UpdateWebhookCredential($id: String!, $environmentId: String!, $name: String, $configuration: JSON!) {
  updateWebhookCredential(
    input: {id: $id, environmentId: $environmentId, patch: {name: $name, configuration: $configuration}}
  ) {
    webhookCredential {
      ...WebhookCredentialDetail
    }
  }
}
    ${WebhookCredentialDetailFragmentDoc}`;

/**
 * __useUpdateWebhookCredentialMutation__
 *
 * To run a mutation, you first call `useUpdateWebhookCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebhookCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebhookCredentialMutation, { data, loading, error }] = useUpdateWebhookCredentialMutation({
 *   variables: {
 *      id: // value for 'id'
 *      environmentId: // value for 'environmentId'
 *      name: // value for 'name'
 *      configuration: // value for 'configuration'
 *   },
 * });
 */
export function useUpdateWebhookCredentialMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWebhookCredentialMutation, UpdateWebhookCredentialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWebhookCredentialMutation, UpdateWebhookCredentialMutationVariables>(UpdateWebhookCredentialDocument, options);
      }
export type UpdateWebhookCredentialMutationHookResult = ReturnType<typeof useUpdateWebhookCredentialMutation>;
export type UpdateWebhookCredentialMutationResult = Apollo.MutationResult<UpdateWebhookCredentialMutation>;
export type UpdateWebhookCredentialMutationOptions = Apollo.BaseMutationOptions<UpdateWebhookCredentialMutation, UpdateWebhookCredentialMutationVariables>;
export const DeleteWebhookCredentialDocument = gql`
    mutation DeleteWebhookCredential($id: String!, $environmentId: String!) {
  deleteWebhookCredential(input: {id: $id, environmentId: $environmentId}) {
    webhookCredential {
      ...WebhookCredentialDetail
    }
  }
}
    ${WebhookCredentialDetailFragmentDoc}`;

/**
 * __useDeleteWebhookCredentialMutation__
 *
 * To run a mutation, you first call `useDeleteWebhookCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWebhookCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWebhookCredentialMutation, { data, loading, error }] = useDeleteWebhookCredentialMutation({
 *   variables: {
 *      id: // value for 'id'
 *      environmentId: // value for 'environmentId'
 *   },
 * });
 */
export function useDeleteWebhookCredentialMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWebhookCredentialMutation, DeleteWebhookCredentialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWebhookCredentialMutation, DeleteWebhookCredentialMutationVariables>(DeleteWebhookCredentialDocument, options);
      }
export type DeleteWebhookCredentialMutationHookResult = ReturnType<typeof useDeleteWebhookCredentialMutation>;
export type DeleteWebhookCredentialMutationResult = Apollo.MutationResult<DeleteWebhookCredentialMutation>;
export type DeleteWebhookCredentialMutationOptions = Apollo.BaseMutationOptions<DeleteWebhookCredentialMutation, DeleteWebhookCredentialMutationVariables>;